import src from "IMAGE";
export default { src, width: 10, height: 10, blurWidth: 0, blurHeight: 0};
